const STORAGE_KEY = "vn_dummy_email_templates_v1";

const stripHtml = (html = "") =>
    String(html)
        .replace(/<style[\s\S]*?<\/style>/gi, " ")
        .replace(/<script[\s\S]*?<\/script>/gi, " ")
        .replace(/<[^>]+>/g, " ")
        .replace(/\s+/g, " ")
        .trim();

export const getDummyTemplates = () => {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
        return [];
    }
};

export const saveDummyTemplates = (templates) => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(templates));
};

export const upsertDummyTemplate = (template) => {
    const templates = getDummyTemplates();
    const index = templates.findIndex((item) => String(item.id) === String(template.id));

    if (index >= 0) {
        templates[index] = { ...templates[index], ...template };
    } else {
        templates.unshift(template);
    }

    saveDummyTemplates(templates);
    return templates;
};

export const deleteDummyTemplate = (id) => {
    const templates = getDummyTemplates().filter((item) => String(item.id) !== String(id));
    saveDummyTemplates(templates);
    return templates;
};

export const getDummyTemplateById = (id) =>
    getDummyTemplates().find((item) => String(item.id) === String(id)) || null;

export const buildShortDescription = (html = "", fallback = "Saved email template") => {
    const text = stripHtml(html);
    if (!text) return fallback;
    return text.length > 90 ? `${text.slice(0, 90).trim()}...` : text;
};

export const openTemplatePreviewWindow = (html, title = "Email Template Preview") => {
    const content = String(html || "").trim();
    if (!content) return;

    const fullHtml = /<html[\s>]/i.test(content)
        ? content
        : `<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><title>${title}</title></head><body style="margin:0;padding:24px;background:#f5f7fb;font-family:Arial,sans-serif;">${content}</body></html>`;

    const previewWindow = window.open("", "_blank");
    if (!previewWindow) return;

    previewWindow.document.open();
    previewWindow.document.write(fullHtml);
    previewWindow.document.close();
};
